module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAYCAYAAAD+vg1LAAABZElEQVRIie3VP0scQRgH4OfOq9TCIiAElHTXCKLBkICglZIIQbA4CxvLYCInscmnuK9gIYIgCP5NGUijGBHRQrGyExSrC5JAYoqdxYssd7t6pMrbLLz7m2dnZ3dnc23lEymrhE/ow23crFaKieF8WhVP0YtcmnAW+Dt+pQ1ngTPVf/jfwJ3obibaPnfak8dznON1k9B9HOWxjQVsYfSR6Ar6MVIQfZ7TaMVnvMX6A9BlTOBVtVLcKdScK+EKa3gjupO06BcMxSgU7mVmRA90C2Ph2AhdDejLaqW4G/eTXrd3WMYmxmv6SZvPSsj8hSbNOK5JXGLV3ZrfogW/Q+YrBpPQejB8CLNcE22X33Adzi0F9EW1UtxLGlwPhvfowCEWcYYN0foPhIslViMYpnCBjzW9fhzUG5QGhvmQncIwjhsNyLIJldGVBs0Kw03aYK6tfDKHJ2r+vI+sHH4UMItnTULj+vkHS5dPigrkCkcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/download/下载.png
// module id = ZOfm
// module chunks = 1